module.exports = __webpack_public_path__ + "static/media/lock-icon.298ed70e.svg";